<template>
    <div>
        <!--------------------------------------radio button----------------------------------------->
        <div class="form-group">
            <div>
                <span class="font-red-sunglo bold">Ajouter un debours ?</span>
                <input type="radio" id="deboursnon"  value="deboursnon" v-model="debourspicked" >
                <label for="deboursnon">Non</label>
                <input type="radio" id="deboursoui" value="deboursoui" v-model="debourspicked">
                <label for="deboursoui">Oui</label>
                <span class="tooltips hidden-xs" data-container="body" data-placement="right" data-html="true" data-template="<div class='tooltip' role='tooltip'><div class='arrow'></div><div class='tooltip-inner tooltip-wide'></div></div>" data-original-title="<div id='tooltip'><p id='text' style='text-align:left;'>
                Règles à respecter frais de débours :
                <ul style='text-align:left;'>
                    <li>Vous devez disposer d'un accord écrit de votre client qui précise la demande de réaliser un achat ainsi que du budget alloué. L'existence de ce contrat permet de vous protéger en cas de contestation et oblige votre client à vous rembourser au centime près les dépenses effectuées en son nom et pour son compte.</li>
                    <li>Vous devez reporter le compte exact de la somme qui a été engagée au centime près. Les factures doivent impérativement être établies au nom de la personne ou de l'organisme qui vous mandate (SIRET, TVA intracommunataire, adresse du siège, etc)</li>
                    <li>Conservez absolument tous vos justificatifs : factures, tickets de caisse et autres récépissés de paiement. Vous devrez les remettre à votre client pour justifier ce qu'il vous doit au titre des débours.</li>
                    <li>Vous devez également conserver des copies de ces justificatifs pour votre propre comptabilité. En cas de contrôle, ils vous seront indispensables pour appuyer votre livre des comptes. Par ailleurs, vous devez y mentionner le terme ‘débours' à côté de la somme correspondante.</li>
                </ul></p></div>">
                    <i class="icon-info"></i>
                </span>
                <span class="tooltips visible-xs" data-container="body" data-placement="top" data-html="true" data-original-title="<div id='tooltip'><p id='text'style='text-align':'left';>
                Frais de débours : ce sont des sommes avancées au nom du client. Ces sommes doivent être remboursées par le client du montant exact.</p></div>">
                    <i class="icon-info"></i>
                </span>
            </div>
        </div>
        <!---------------------------------------End radio button----------------------------------------->

        <!---------------------------------------Select Débours ----------------------------------------->

        <div class="row" v-show="debourspicked == 'deboursoui'">
            <div class="col-md-4">
                <label> Débours Frais (en €)</label>
                <input type="number" ref="input" name="debours" step="0.01" min="0"
                class="form-control"  v-model="billing.debours" />
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "addDeboursComponent",
        props: {
            billing: {
                type: Object,
                default: () => {
                    return []
                }
            },
        },
        data () {
            return {
                'debourspicked' : 'deboursnon',
            }
        },
        mounted () {
            if(this.billing.debours ){
                this.debourspicked = 'deboursoui'
            }
        },
        watch: {
            'debourspicked' : function (newVal, oldVal)//button picked
            {
                if(this.debourspicked ==  'deboursnon' && oldVal!="")
                {
                    this.billing.debours = null
                }
            }
        }
    }
</script>
<style>
    .tooltip-wide {
        max-width: 500px !important;
        width: 500px;
    }
    .tooltip-wide>#tooltip{
        max-width: 480px !important;
    }
</style>
